export default class FeatureFlag {
  key: string;
  variation: string | null;
  enabled: boolean;

  constructor(key: string, variation: string | null, enabled: boolean) {
    this.key = key;
    this.variation = variation;
    this.enabled = enabled;
  }
}
